import {ID} from '~/lib/model';

export const businessIncentivesLinks = {
    businessIncentives: () => '/expenses',
    businessIncentive: (id: ID) => `/expenses/${id}`,
};
